import React, { FunctionComponent, useEffect, useState } from "react"
import HRRService from "./utils/HRRService"
import HRRRunReport from "./HRRRunReport/HRRRunReport"
import HRRViewReport from "./HRRViewReport/HRRViewReport"
import HRRReportsTable from "./HRRReportsTable/HRRReportsTable"
import "./HRReports.css"

const HRReports: FunctionComponent = () => {

    const [state, setState] = useState(HRRService.state)
    const { selectedReport, viewReport } = state

    useEffect(() => {
        //@ts-ignore
        HRRService.webWorker.addEventListener("message", (event: { data: any }) => {
            setState(event.data)
        })
    }, [])

    return (
        <div className="HRReports main-content col-sm">
            <HRRReportsTable/>
            {selectedReport && !viewReport && <HRRRunReport />}
            {viewReport && <HRRViewReport />}
        </div>
    )
}

export default HRReports
